import { createSelector } from "reselect";

import { selectAllFiles } from "./files.slice";

export const selectFilesForWorkspace = createSelector(
	[selectAllFiles, (_, workspaceId: string) => workspaceId],
	(allFiles, workspaceId) => allFiles.filter((file) => file.workspaceId === workspaceId),
);
